import {
  SET_LOCKS,
  SET_LOCKS_TABKEY,
  SET_LOCKS_PAGE,
  SET_LOCKS_UPDATED,
} from '../constants/LockConstants';

const initialState = {
  // 暂时没用
  tabKey: 'all',
  page: 1,
  locks: {
    list: [],
    tree: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOCKS: {
      return {
        ...state,
        locks: action.payload,
        updated: false,
      };
    }

    case SET_LOCKS_TABKEY: {
      return {
        ...state,
        tabKey: action.payload,
      };
    }

    case SET_LOCKS_PAGE: {
      return {
        ...state,
        page: action.payload,
      };
    }

    case SET_LOCKS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default:
      return state;
  }
}
